var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.$t(`Select.difficulty_level_note_${_vm.level.id}`), html: true }),expression:"{ content: $t(`Select.difficulty_level_note_${level.id}`), html: true }"}],staticClass:"totem-learningpath-level"},[_vm._v("\n    "+_vm._s(_vm.level.id)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }